import GeneralFilter from '../../../../Model/GeneralFilter'

export default class TrainerFilter extends GeneralFilter {
  constructor () {
    super()
    this.setInitialValue()
  }

  setInitialValue () {
    this.setFilterInitialValue()
  }
}
